import { useAccess } from "./AccessProvider";
import { CapabilityKey } from "./capabilities";

/**
 * Whether the signed-in user may do `capability` in the organisation the session acts in.
 * False while access is loading, after it failed, for an unusable account, after a switch the
 * server did not honour, and for any key not granted. Only `ready` and `refreshing` grant.
 */
export const useCan = (capability: CapabilityKey): boolean => useAccess().can(capability);
